import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { removeInventoryItemService } from '../services/removeInventoryItemService';
import { RemoveInventoryItemSchema } from '../types/RemoveInventoryItemSchema';

const initialState: RemoveInventoryItemSchema = {
    showDialog: false,
    pendingItemIds: null,
};

export const RemoveInventoryItemSlice = createSlice({
    name: 'RemoveInventoryItem',
    initialState,
    reducers: {
        setShowDialog: (state, action: PayloadAction<boolean>) => {
            state.showDialog = action.payload;
            if (!action.payload) {
                state.pendingItemIds = null;
            }
        },
        openForItems: (state, action: PayloadAction<string[]>) => {
            state.pendingItemIds = action.payload;
            state.showDialog = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(removeInventoryItemService.pending, (state) => {
                state.error = undefined;
                state.isLoading = true;
            })
            .addCase(removeInventoryItemService.fulfilled, (state) => {
                state.isLoading = false;
                state.pendingItemIds = null;
                toast('Items removed from Inventory');
            })
            .addCase(removeInventoryItemService.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { actions: removeInventoryItemActions } = RemoveInventoryItemSlice;
export const { reducer: removeInventoryItemReducer } = RemoveInventoryItemSlice;
